<template>
  <div>
  <section class="main">
    <header>
      <h1>Innovation with Energy.</h1>
    </header>

    <div class="board">
      <nav>
        <router-link to="startup-innovation" class="tile"><svg>
          <use xlink:href="#rocket"></use>
        </svg>
          <div><h2>Start-up Innovation</h2></div>
        </router-link>
        <router-link to="corporate-innovation" class="tile"><svg>
          <use xlink:href="#train"></use>
        </svg>
          <div><h2>Corporate Innovation</h2></div>
        </router-link>
        <router-link to="smart-energy-systems" class="tile"><svg>
          <use xlink:href="#grid"></use>
        </svg>
          <div><h2>Smart Energy Systems</h2></div>
        </router-link>
        <router-link to="future-energy-system" class="tile"><svg>
          <use xlink:href="#circle"></use>
        </svg>
          <div><h2>Future Energy System</h2></div>
        </router-link>
        <router-link to="cleantech-startup-map" class="tile"><svg>
          <use xlink:href="#map"></use>
        </svg>
          <div><h2>Cleantech Startup Map</h2></div>
        </router-link>
        <router-link to="contact-about" class="tile"><svg>
          <use xlink:href="#bubble"></use>
        </svg>
          <div><h2>Contact | About</h2></div>
        </router-link>
      </nav>
      <router-view></router-view>
    </div>


  </section>
  <section id="partners">
    <h3>Clients and partners</h3>

    <div class="partners">
      <a href="//www.rwe.de" target="_blank"><img class="rwe-innovation" alt="RWE Innovation Hub" title="RWE Innovationhub" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.enel.it" target="_blank"><img class="enel" alt="Enel" title="Enel" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.laboratories.telekom.com" target="_blank"><img class="telekominnovation" alt="Telekom Innovation Labs" title="Telekom Innovation Labs" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.dena.de" target="_blank"><img class="dena" alt="Dena" title="Dena" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.startupnight.de" target="_blank"><img class="langenacht" alt="Lange Nacht der Startups" title="Lange Nacht der Startups" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.climate-kic.org" target="_blank"><img class="eitclimate" alt="EIT Climate kic" title="EIT Climate kic" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="></a>
      <a href="//www.hubraum.com" target="_blank"><img class="hubraum" alt="hubraum" title="hubraum" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.entrepreneurship.tu-berlin.de" target="_blank"><img class="cfe" alt="CfE Logo" title="Centre for Entrepreneurship" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="></a>
      <a href="//www.incense-accelerator.com" target="_blank"><img class="incense" alt="Incense Energy Accelerator" title="Incense Energy Accelerator" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="></a>
      <a href="//cleantechpark.de" target="_blank"><img class="cleantech" alt="Cleantech Businesspark Berlin-Marzahn" title="Cleantech Businesspark Berlin-Marzahn" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.eitdigital.eu/idea-challenge/about/" target="_blank"><img class="ideachallenge" alt="EIT Idea Challenge" title="EIT Idea Challenge" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.rohrbeckheger.com" target="_blank"><img class="rohrbeckheger" alt="Rohrbeck Heger GmbH" title="Rohrbeck Heger GmbH" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.eitdigital.eu" target="_blank"><img class="eitdigital" alt="EIT Digital Logo" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII=">
      </a>
      <a href="//www.vattenfall.de" target="_blank"><img class="vattenfall" alt="vattenfall" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEAAQMAAABmvDolAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAAB9JREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAL4NIQAAAWDknZcAAAAASUVORK5CYII="></a>
    </div>
  </section>
  <footer>
    <ul>
      <li><a href="impressum">Impressum</a></li>
      <li><a href="privacy">Datenschutz</a></li>
    </ul>
  </footer>
    </div>
</template>

<script>
  export default {
    name: 'hello'
  }

</script>

<style>
  .cfe, .cleantech, .dena, .eitclimate, .eitdigital,
  .enel, .hubraum, .ideachallenge, .incense, .langenacht,
  .rohrbeckheger, .rwe-innovation, .telekominnovation, .vattenfall
  { max-width: 70%; background-size: 110%; background-image: url('../assets/logdos.png'); }

  .cfe { background-position: 0 0%; background-size: 100%; }
  .cleantech { background-position: 0 7.142857%; background-size: 100%; }
  .dena { background-position: 0 14.285714%; background-size: 100%; }
  .eitclimate { background-position: 0 21.428571%; background-size: 100%; }
  .eitdigital { background-position: 0 28.571429%; background-size: 100%; }
  .enel { background-position: 0 35.714286%; background-size: 100%; }
  .hubraum { background-position: 0 42.857143%; background-size: 100%; }
  .ideachallenge { background-position: 0 50%; background-size: 100%; }
  .incense { background-position: 0 57.142857%; background-size: 100%; }
  .langenacht { background-position: 0 64.285714%; background-size: 100%; }
  .rohrbeckheger { background-position: 0 71.428571%; background-size: 100%; }
  .rwe-innovation { background-position: 0 78.571429%; background-size: 100%; }
  .telekominnovation { background-position: 0 85.714286%; background-size: 100%; }
  .vattenfall { background-position: 0 100%; background-size: 100%; }
  .content-div, .overlay-inner {
    position: absolute;
    text-align: left;
    margin: 1em;
    background-color: white;
    border: solid rgba(72, 255, 0, 1) 5px;
    font-family: Evj34;
    display: block;
    padding: 2em;
    max-height: 90vh;
    lost-center: 90%;
  a {
    color: gray;
    font-family: Fgt5!important;
  }
  a:hover {
    color: black;
  }
  .versa {
    text-transform: uppercase;
    font-size: 0.845em;
  }
  h2 {
    position: relative;
    letter-spacing: 1px;
    margin: 0 0 1em 0;
    width: 100%;
    text-align: left;
    top:0;
    font-family: Fgt5;
    font-size: 1em;
    min-height: 100%;
    color: rgba(72, 255, 0, 1);
    text-transform: uppercase;
    background: none;
  }
  h3 {
    text-align: left;
    font-family: Fgt5;
    color: rgba(72, 255, 0, 1);
    font-size: .9em;
    margin: 1em 0;
    text-transform: uppercase;
    text-decoration: none;
  }
  p {
    position: relative;
    font-family: Evj34;
    font-size: 0.875em;
    text-align: justify;
  .reference {vertical-align : super;
    font-size: .6em;}
  }
  .footnote {
    vertical-align: super;
    font-size: 0.8em;}
  ul {  list-style: none;
    padding-left: 0;
  }
  li {
    font-size: 1em;
  };


  li:before {
    font-family: Fgt5;
    content: "";
    padding-right: 0;
    color: rgba(72, 255, 0, 1);
  }
  li {
    text-transform: none;
    font-family: Evj34;
  }

  .first {
    font-family: Evj34;
    font-size: 0.75em;
    text-align: justify;
  }
  .highlight {
    text-transform: uppercase;
  }
  .years {
    list-style: none;
    padding-left: 0;
  li {
    font-family: Evj34;
    text-transform: none;
    font-size: 0.875em;}
  span {
    font-family: Fgt5;
    font-size: 1em;
    padding-right: 0.3em;
  }
  li:before {
    font-family: Fgt5;
    content: none;
    padding-right: 0;
  }
  }

  .end {
    height: 30px;
  }
  ul {
    list-style: none;
    padding-left: 0;
  }

  li:before {
    font-family: Fgt5;
    content: ">";
    padding-right: 8px;
    color: rgba(72, 255, 0, 1);
  }
  li {
    text-transform: none;
    font-family: Dveve53;
    font-size: 0.9em;
  }
  }
  .overlay {
    display: block;
    lost-center: 90vw;
    /* dimensions: spanning the background from edge to edge */
    position:absolute;
    z-index: 2147483647; /* z-index needs to be >= elements on the site. */
    /* position: centering content */
    text-align: center;
    /* insures that the ::before pseudo element doesn't force wrap with fixed width content; */
    white-space: nowrap;

    /* styling */
    cursor: pointer;
    background: none;
  }


  .overlay:before {
    /* position: trick to center content vertically */
    content: '';
    display: block;
    vertical-align: middle;
    margin-right: -0.25em;
  }
  .noscroll {
    position:fixed;
    overflow: hidden;
  }
  .disab { pointer-events: none;}

  .overlay .overlay-content {
    /* make content container for positioned elements (close button) */
    position: relative;
    /* position: centering vertical and horizontal */
    text-align: left;
    display: block;
    max-height: 60vh;


    /* dimensions: cut off images */
    overflow: hidden;
    padding: 1em 1em 2em 1em;
    border: solid rgba(72, 255, 0, 1) 5px;
    /* dimensions: handling small or empty content */


    /* dimensions: handling large content */

    /* styling */
    background: #fff;
    cursor: auto;

    /* reset white-space wrapping */
    white-space: normal;

  }

  .overlay .overlay-inner {
    /* make sure its visible */
    position: relative;
    display: block;
    max-height: 47vh;
    border: none!important;
    overflow: auto;
    margin-bottom: 5em;
    padding: 2em 4em 2em 2em;
    overflow-x: hidden;
    margin-right: -3em;
  }
  .overlay .overlay-close {
    /* position: centering vertical and horizontal */
    position: absolute;
    z-index: 9999;
    top: 0;
    right: 0;

    /* dimensions: 25px x 25px */
    line-height: 35px;
    width: 35px;

    /* styling */
    cursor: pointer;
    text-align: center;
    font-family: Fgt5, sans-serif;
    font-size: 1em;
    color: black;
    background: #fff; /* Set the background in case it overlaps the content */
    background: rgba(255, 255, 255, 0.3);
  }
  .cleanmap {
    min-width: 66vw;
  }
  @media screen and (min-width: 500px) {
    h2 {
      font-size: 0.67em;
      margin-top: -0.9em;
    }
    h3 {
      text-align: center;
      font-size: 1.5em;
      margin: 0 auto 0.5em auto;
    }
    .main > .content-div {
      position: relative;
      padding: 2em;
      lost-center: 70vw;
      max-height: 60vh;
    }
    .board, .overlay {
      lost-center: 62vw;
    }
    .tile {
      lost-column: 1/3;

    }
    .board .tile div {

      min-height: 3.5em;
    }

    .overlay {
      max-height: 25em;
      padding-bottom: 5em;
      lost-center: 70vw;
      margin-left: -5%;
      min-width: 68vw;
    }
    .overlay .overlay-content {
      max-height: 59vh;

    }
    .overlay .overlay-inner {
      max-height: 46vh;
    }
    /* Partners */
    #partners {
      margin-top: 1em;
      padding-top: 1em;
    }

    .partners {
      lost-center: 85%;
      margin-top: 1em;
    }
    .partners a {
      lost-column: 1/4;
    }

    /* Footer */
    footer {
      margin: 5% auto 2em auto;
    }
  }


  @media screen and (min-width: 768px) {
    h1 {
      font-size: 1.75em;
      padding-top: 2.5em;
      margin-top: 0px;
    }

    .main {
      display: block;
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 99%, rgba(255, 255, 255, 1) 100%), url("../assets/berlin_grid_medium.jpg");
      background-position: top right;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .board {
      margin-top: 8vh;
    }

    .overlay .overlay-content {
      max-height: 23em;

    }
    .overlay .overlay-inner {
      max-height: 18em;
    }

    #partners {

      margin-top: 2em;
      padding-top: 2.5em;
    }

  }


  @media screen and (min-width: 1200px) {
    h1 {
      font-size: 1.75em;
      padding-top: 1em;
    }
    h2 {
      font-size: 0.80em;
      margin-top: -0.5em;
    }
    h3 {
      font-size: 1.6em;
    }
    .board .tile div {
      min-height: 3.3em;
    }

    .tile {
    svg {
      max-height: 8em;
    }
  }
  .main > .content-div {
    position: relative;
    lost-center: 65%;
    max-height: 23em;
  }
  .overlay {
    lost-center: 65%;
    margin-left: -2.5%;
  }
  .cleanmap {
    lost-center: 70vw;
  }


  #partners {
    lost-center: 62vw;

  }
  }


  @media screen and (min-width: 1340px) {
    h1 {
      font-size: 2.4em;

    }
    h2 {
      margin-top: -0.8em;
    }
    .board {
      margin-top: 8vh;
      lost-center: 50vw;
    }

    .tile {
    svg {
      max-height: 15em;
    }

  }

  .board .tile div {
    min-height: 3.5em;
  }
  .main > .content-div {
    position: relative;
    lost-center: 60%;
    max-height: 30em;
  }
  .overlay {
    lost-center: 60%;
    margin-left: -5.5%;
    min-width: 60%;
  }
  .cleanmap {
    min-height: 27em;
  }

  .overlay .overlay-content {
    max-height: 30em;

  }

  .overlay .overlay-inner {
    max-height: 25em;
  }

  }

  @media screen and (min-width: 1600px) {
    h2 {
      font-size: 0.85em;
      height: 2em;
      padding: .2em;
    }

    .cleanmap {
      min-width: 66vw;
      max-width: 60%;
      min-height: 27em;
    }

    .main {
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 99%, rgba(255, 255, 255, 1) 100%), url("../assets//berlin_grid_high.jpg");
      background-position: top right;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .main > .content-div {
      max-height: 42em;
    }

    .overlay .overlay-content {
      max-height: 42em;

    }

    .overlay .overlay-inner {
      max-height: 35em;
    }

  }
</style>



// WEBPACK FOOTER //
// Hello.vue?98f54066